module.exports = __webpack_public_path__ + "static/media/note-taker.3ef2869b.png";